const it = {
  translation: {
    lang: "it",
    clickToEnableSound: "Fare clic per abilitare l'audio",
    reinvented: {
      title: "DIOR REINVENTED BY PHILIPPE STARCK",
      reinvented: [
        {
          letter: "R",
        },
        {
          letter: "E",
        },
        {
          letter: "I",
        },
        {
          letter: "N",
        },
        {
          letter: "V",
        },
        {
          letter: "E",
        },
        {
          letter: "N",
          attributes: {
            "data-rotation": "",
          },
          className: "yellow",
        },
        {
          letter: "T",
        },
        {
          letter: "A",
        },
        {
          letter: "T",
        },
        {
          letter: "O",
        },
      ],
      by: [
        {
          letter: "D",
        },
        {
          letter: "A",
        },
      ],
      subtitle: "la poltrona Médaillon immaginata da Philippe Starck",
      intro: "Storia di un’icona reinventata",
      description: [
        "Simbolo dello stile Luigi XVI tanto caro a Christian Dior, la sedia Médaillon viene reinterpretata da Philippe Starck in una poltrona inedita, ispirata alla figura emblematica dello stilista fondatore della Maison.",
        "Battezzato Monsieur Dior, questo eccezionale modello, disponibile in diversi materiali e colori, coniuga i canoni estetici di Dior con una straordinaria maestria che ridefinisce i limiti dell’eccellenza.",
        "Determinato a proseguire la sua ricerca del minimo, Philippe Starck ha creato un oggetto d’arte e del desiderio, che si accompagna stavolta a una collezione di arredi, la più completa mai realizzata finora dalla Maison, ampliando così la “famiglia Dior by Starck” e riflettendo la libertà e l’inventiva del dialogo tra Dior e il creatore francese.",
      ],
    },
    ellemurmura: {
      title:
        "Il creatore francese è riuscito, attraverso diverse varianti di questo modello inedito, a rivelare la vera essenza del mito che la sedia Médaillon rappresenta ai suoi occhi, esaltando in particolare la delicatezza dell’iconico motivo Toile de Jouy.",
    },
    discover: "Scoprire Miss Dior Sweet",
    colorsAndFabrics: {
      title: "Colori e tessuti",
      description:
        "Simboli di una maestria eccezionale che coesiste con le tecnologie più avanzate, questi straordinari oggetti realizzati in Italia, disponibili in diversi materiali e colori (dall’alluminio lucido o laccato al tessuto bouclé, fino alla Toile de Jouy rosa, nera o arancione fluo).",
      closing_paragraph:
        "Si circondano di una nuova famiglia: “tanti fratelli e sorelle minori, tra cui tavoli di diverse misure e sgabelli, tutti estremamente raffinati”, come spiega il celebre creatore francese che ha concepito questa serie esclusiva.",
    },
    collection: "Un'intera collezione immaginata da Philippe Starck",
    biography: {
      headline:
        "Creatore francese di fama internazionale, Philippe Starck è considerato uno dei pionieri del design democratico",
      description:
        "Philippe Starck, è considerato uno dei pionieri del design democratico, celebre per le sue opere visionarie e poetiche che toccano numerosi ambiti: design, architettura, decorazione d’interni o persino trasporti. Dalla sua infanzia trascorsa sotto i tavoli da disegno del padre, ingegnere aeronautico, Starck ha imparato una lezione fondamentale: tutto va ordinato in maniera elegante e rigorosa, sia nei rapporti umani che nella visione che precede ogni gesto creatore.",
      description_bis:
        "La sua profonda comprensione dei cambiamenti che caratterizzano la nostra epoca, il suo entusiasmo per la creazione di nuovi stili di vita, il suo amore per le idee, il desiderio di difendere l’intelligenza dell’utilità (e l’utilità dell’intelligenza) gli hanno permesso di spingersi costantemente al di là dei limiti del savoir-faire contemporaneo. Con oltre 10.000 creazioni alle spalle e un’inesauribile inventività, questo cittadino del mondo continua a perseguire la sua missione: progettare luoghi e oggetti il cui scopo sia innanzitutto quello di funzionare “bene”, ancor prima di essere esteticamente belli.",
    },
    scenography: "Scenografia",
    savoir_faire: {
      an: [
        {
          letter: "U",
          attributes: {
            "data-rotation": "",
          },
          className: "yellow",
        },
        {
          letter: "N",
        },
        {
          letter: "'",
        },
      ],
      unique: [
        {
          letter: "E",
        },
        {
          letter: "C",
        },
        {
          letter: "C",
        },
        {
          letter: "E",
        },
        {
          letter: "Z",
        },
        {
          letter: "I",
        },
        {
          letter: "O",
        },
        {
          letter: "N",
        },
        {
          letter: "A",
        },
        {
          letter: "L",
        },
        {
          letter: "E",
        },
      ],
      savoir: [
        {
          letter: "M",
        },
        {
          letter: "A",
        },
        {
          letter: "E",
        },
        {
          letter: "S",
          attributes: {
            "data-rotation": "",
          },
          className: "salmon",
        },
        {
          letter: "T",
        },
        {
          letter: "R",
        },
        {
          letter: "I",
        },
        {
          letter: "A",
        },
      ],
      faire: [],
      intro:
        "Realizzata in Italia, questa “collezione di arredi haute couture” trascende i confini del possibile, combinando la poesia della manualità con nuove avanzate tecnologie.",
      bring:
        "Per dare vita a queste straordinarie creazioni di estrema finezza, Philippe Starck si è rivolto ad artigiani italiani il cui virtuosismo è testimoniato da una straordinaria padronanza dei materiali durante la fase decisiva di scorrimento del metallo.",
      specialist:
        "Specialista nello stampaggio a iniezione, ha sviluppato un processo unico ed elaborato e ha selezionato l'alluminio della massima purezza per garantire che ogni realizzazione sia della massima finezza.",
      molten:
        "Una volta fuso, l'alluminio liquido viene versato in un serbatoio di cemento chiamato crogiolo, e quindi iniettato in uno stampo meticolosamente regolato. Un'enorme padronanza del materiale viene quindi implementata per produrre una forma infinitamente precisa, adattata all'insolita architettura di questa creazione.",
      cleansed:
        "Successivamente i pezzi vengono ripuliti da eventuali imperfezioni in una fase di lucidatura finale prima di essere immersi in un bagno elettrolitico per le versioni cromo nero e rame rosa, o spruzzati sottovuoto per quella oro.",
      longevity:
        "La longevità è un parametro fondamentale negli sforzi creativi di oggi. Grazie al suo design senza tempo e all'estrema durabilità dei suoi materiali, Miss Dior by Starck rivela un'eterna aura culturale, storica e simbolica.",
    },
  },
};

export default it;
